import { render } from "./BookAppointment.vue?vue&type=template&id=454fa188&scoped=true"
import script from "./BookAppointment.vue?vue&type=script&lang=js"
export * from "./BookAppointment.vue?vue&type=script&lang=js"

import "./BookAppointment.vue?vue&type=style&index=0&id=454fa188&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454fa188"]])

export default __exports__